import { useSecureFileUrl } from "@tellescope/tanstack-query";
import { BookOpen, FileText, Video } from "lucide-react";
import type { AttachFileDialogContentModel } from "./types";

export interface ManagedContentPreviewProps {
  type?: AttachFileDialogContentModel["type"];
  headerPhoto?: string;
  title: string;
}

const iconForType = (type?: AttachFileDialogContentModel["type"]) => {
  if (type === "PDF") return FileText;
  if (type === "Video") return Video;
  return BookOpen;
};

export const ManagedContentPreview = ({ type, headerPhoto, title }: ManagedContentPreviewProps) => {
  const isUrl = headerPhoto?.startsWith("http") ?? false;
  const secureUrl = useSecureFileUrl(headerPhoto && !isUrl ? headerPhoto : undefined);
  const src = isUrl ? headerPhoto : secureUrl;

  if (src) {
    return <img src={src} alt={title} className="h-12 w-12 flex-shrink-0 rounded object-cover" />;
  }

  const Icon = iconForType(type);
  return (
    <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded bg-gray-100 text-gray-500">
      <Icon className="h-5 w-5" />
    </span>
  );
};
